import { VITE_USE_MOCK, VITE_MOCK_API, VITE_CASE_DATA_API } from 'Constants/appEnvConstants'

export function getCaseDataBaseUrl() {
  // eslint-disable-next-line no-undef
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_CASE_DATA_API;
}
